import CustomCard from '../../../../../components/CustomCard';
import CustomTab from '../../../../../components/CustomTab';
import CustomTabContainer from '../../../../../components/CustomTabContainer';
import React from 'react';
import WorkShiftsSelect from './Components/WorkShiftsSelect';
import AccessRightsApp from './Funtionality/AccessRightsApp';
import SectionSelected from '../../../Events/Requested/SubComponents/SectionSelected';
import {CleanIcon, IconAccessRight} from '../../../../../components/buttons/IconButtons';
import WorkShiftsItem from './Components/WorkShiftsItem';
import CustomizedItem from './Components/CustomizedItem';
import CustomizedSchedule from './Components/CustomizedSchedule';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const AccessRights = (
    {
        workShiftsList, setWorkShiftsList,
        customizedList, setCustomizedList,
        user,
        resetForm,
        contractorItemId,
        isEditable
    }
) => {

    const {
        t,
        TABS_ACCESS_RIGHT, MODEL_TABS_ACCESS_RIGHT,
        optionTabSelected, setOptionTabSelected,
        handleWorkShiftsDelete,
        handleCustomizedDelete
    } = AccessRightsApp({
        workShiftsList, setWorkShiftsList,
        customizedList, setCustomizedList,
        contractorItemId,
        isEditable,
        user
    });

    return (
        <>
            { (!user?.id) &&
                <div className={"mb-2 d-flex justify-content-end"}>
                    <ButtonIcon
                        className='btn-clean-secondary-600'
                        id='btn_ac_clean_all_inputs'
                        Icon={CleanIcon}
                        title={'clear_instances'}
                        onClick={resetForm}
                        iconProps='btn-icon-svg-12px icon-color-general-00'
                    />
                </div>
            }

            <CustomCard classes={"w-100"} classCard={'card-border-8px'}>
                <div className='row g-3'>
                    <div className='col-sm-12 col-md-12 col-lg-7 px-0'>
                        <CustomTabContainer
                            activeTab={optionTabSelected}
                            setActiveTab={(e) => {
                                setOptionTabSelected(e);
                            }}
                            className="border-0 px-0"
                        >
                            {TABS_ACCESS_RIGHT.map((item) => (
                                <CustomTab
                                    key={item.key}
                                    id={item.key}
                                    title={t(item.translation)}
                                    icon={item.icon}
                                    selected={optionTabSelected === item.key}
                                    onClick={() => {
                                        setOptionTabSelected(item.key)
                                    }}
                                />
                            ))}
                        </CustomTabContainer>

                        <div className="border-bottom-shades-300 mt-2 mb-4" />

                        {optionTabSelected === MODEL_TABS_ACCESS_RIGHT.WORK_SHIFT.NAME &&
                            <WorkShiftsSelect
                                workShiftsList={workShiftsList}
                                setWorkShiftsList={setWorkShiftsList}
                                autoHeight={false}
                            />
                        }

                        {optionTabSelected === MODEL_TABS_ACCESS_RIGHT.CUSTOM_SHIFT.NAME &&
                            <CustomizedSchedule
                                customizedList={customizedList}
                                setCustomizedList={setCustomizedList}
                                autoHeight={false}
                            />
                        }

                    </div>
                    <div className='col-sm-12 col-md-12 col-lg-5 pl-sm-0 pl-lg-3 pr-0 mt-19px d-flex flex-column'>
                        <SectionSelected
                            title="access_rights"
                            icon={<IconAccessRight className={"mr-8px mb-1 icon-color-general-950"} />}
                            autoHeight={false}
                        >
                            <WorkShiftsItem
                                t={t}
                                list={workShiftsList}
                                setList={setWorkShiftsList}
                                onDelete={(index)=>{
                                    handleWorkShiftsDelete(index)
                                }}
                            />
                            <CustomizedItem
                                t={t}
                                list={customizedList}
                                setList={setCustomizedList}
                                title={"custom_access"}
                                onDelete={(index)=>{
                                    handleCustomizedDelete(index);
                                }}
                            />
                        </SectionSelected>
                    </div>
                </div>
            </CustomCard>
        </>
    );

}

export default AccessRights
